import { useQuery } from '@tanstack/react-query';
import api from '~/api';
import { useIsCorsoCxAgent } from '~/hooks/useIsCorsoAdmin';
import { useStoreId } from '~/providers/StoreUserProvider';

export function useShippingClaimInventoryLevelsQuery(shippingClaimId: number) {
  const storeId = useStoreId();
  const isCorsoCxAgent = useIsCorsoCxAgent();

  return useQuery({
    enabled: !!shippingClaimId && isCorsoCxAgent,
    throwOnError: false,
    queryKey: ['shippingClaimInventoryLevels', shippingClaimId, storeId],
    queryFn: () =>
      api
        .store(storeId)
        .shippingProtection.claim(`${shippingClaimId}`)
        .inventoryLevels(),
  });
}
